'use client'

import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import { useState, useEffect } from 'react'
import AuthInitializer from '@/components/auth/AuthInitializer'
import ProfileCompletionWrapper from '@/components/auth/ProfileCompletionWrapper'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 minutes
      },
    },
  }))

  // Initialize fetch interceptor after React context is ready
  useEffect(() => {
    import('@/lib/fetchInterceptor')
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <AuthInitializer>
        <ProfileCompletionWrapper>
          {children}
        </ProfileCompletionWrapper>
      </AuthInitializer>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          error: {
            duration: 6000,
          },
        }}
      />
    </QueryClientProvider>
  )
} 